import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { MenuIcon, XIcon } from "lucide-react";
import { navSections } from "../../data/site";
import { useActiveSection } from "../../hooks/useActiveSection";
const ids = navSections.map(s => s.id);
export function SiteNav() {
  const active = useActiveSection(ids);
  const [open, setOpen] = useState(false);
  return <header className="fixed inset-x-0 top-0 z-40" data-id="element-648" data-mp="17mt6yye5wew0">
      <div className="relative mx-auto flex max-w-[1400px] items-center justify-between gap-4 px-5 py-4 md:px-8" data-id="element-649" data-mp="17oe48vrv2bxk">
        <nav aria-label="Sections" className="absolute left-1/2 hidden -translate-x-1/2 rounded-full bg-ink p-1.5 md:flex" data-id="element-650" data-mp="12tqgx08lfnkk">
          {navSections.map(s => <a key={s.id} href={`#${s.id}`} aria-current={active === s.id ? "true" : undefined} className={`rounded-full px-4 py-2 text-[13px] font-semibold uppercase tracking-wide transition-colors duration-150 ${active === s.id ? "bg-sun text-ink" : "text-cream hover:text-sun"}`} data-id="element-651" data-mp="twg2j60hbibf">
              {s.label}
            </a>)}
        </nav>

        <div className="ml-auto flex items-center gap-2" data-id="element-652" data-mp="bwaq68yz8p56">
          <a href="#live" className="hidden rounded-full border border-ink bg-sun/80 px-5 py-2.5 text-[13px] font-semibold uppercase tracking-wide text-ink backdrop-blur transition-colors duration-150 hover:bg-ink hover:text-sun sm:inline-block md:hidden lg:inline-block" data-id="element-653" data-mp="bxvhzqtwptzc">
            Watch live
          </a>
          <button type="button" onClick={() => setOpen(true)} aria-label="Open menu" className="flex h-12 w-16 items-center justify-center rounded-full bg-ink text-cream md:hidden" data-id="element-654" data-mp="un1ugw43xpcp">
            <MenuIcon className="h-5 w-5" data-id="element-655" data-mp="3fb7s9gbbyw2k" />
          </button>
        </div>
      </div>

      <AnimatePresence data-id="element-656" data-mp="3kcndb8did2ky">
        {open && <motion.div className="fixed inset-0 z-50 flex flex-col bg-sun px-5 py-4 md:hidden" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} data-id="element-657" data-mp="3k9hq5yofwarv">
            <div className="flex items-center justify-between" data-id="element-658" data-mp="1h1hb1fng3swo">
              <span className="font-display text-[20px] uppercase leading-[0.95]" data-id="element-659" data-mp="1c50mwlg8xejl">
                Engineering
                <br data-id="element-660" data-mp="1767bcykirxm2" />
                Entrepreneurship
                <br data-id="element-661" data-mp="133ke2i52xkhh" />
                Challenge
              </span>
              <button type="button" onClick={() => setOpen(false)} aria-label="Close menu" className="flex h-12 w-16 items-center justify-center rounded-full bg-ink text-cream" data-id="element-662" data-mp="1329aaibmwcqd">
                <XIcon className="h-5 w-5" data-id="element-663" data-mp="2siqsxxqxecvv" />
              </button>
            </div>
            <nav aria-label="Sections" className="mt-12 flex flex-col" data-id="element-664" data-mp="2njnpuiuiagqj">
              {navSections.map((s, i) => <motion.a key={s.id} href={`#${s.id}`} onClick={() => setOpen(false)} initial={{
            opacity: 0,
            y: 12
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.22,
            delay: i * 0.04,
            ease: [0.23, 1, 0.32, 1]
          }} className="border-b border-ink/20 py-3 font-display text-6xl uppercase" data-id="element-665" data-mp="2v3os3f585z26" data-mpi={i}>
                  {s.label}
                </motion.a>)}
            </nav>
          </motion.div>}
      </AnimatePresence>
    </header>;
}